import { defineMessages } from 'react-intl';

export default defineMessages({
  showMoreTeachers: {
    id: 'teachers.page.showmore.title',
    defaultMessage: 'Voir plus de professeurs ',
  },
});
